<template>
  <header class="header-main">
    <b-navbar toggleable="xl" class="align-items-center justify-content-center">
      <b-navbar-toggle
        class="navbar-toggle"
        target="nav-collapse"
        @click="toggleMobileMenu"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </b-navbar-toggle>

      <b-navbar-brand :href="siteInfo.home_url || mainWebsiteUrl">
        <template v-if="siteInfo.site_logo">
          <img
            class="black-logo"
            :src="siteInfo.site_logo"
            :alt="siteInfo.name || 'MyWhoosh'"
          />
        </template>
        <template v-else>
          <strong class="black-logo site-name-fallback">
            {{ siteInfo.name || "MyWhoosh" }}
          </strong>
        </template>

        <template v-if="siteInfo.site_logo_dark">
          <img
            class="white-logo d-none"
            :src="siteInfo.site_logo_dark"
            :alt="siteInfo.name || 'MyWhoosh'"
          />
        </template>
        <template v-else>
          <strong class="white-logo d-none site-name-fallback">
            {{ siteInfo.name || "MyWhoosh" }}
          </strong>
        </template>
      </b-navbar-brand>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="w-100">
          <b-nav-item
            v-for="item in sortedMenuItems.filter(
              (item) => !hasChildren(item.ID)
            )"
            :class="{ split: item.classes.includes('split') }"
            :key="item.ID"
            :href="item.url"
            :target="item.target || '_self'"
            :title="item.attr_title"
            :disabled="item.classes.includes('split')"
          >
            {{ item.classes.includes("split") ? "" : item.title }}
          </b-nav-item>

          <b-nav-item-dropdown
            v-for="item in sortedMenuItems.filter((item) =>
              hasChildren(item.ID)
            )"
            :key="item.ID"
            right
          >
            <template #button-content>
              {{ item.title }}
            </template>
            <b-dropdown-item
              v-for="child in getChildren(item.ID)"
              :key="child.ID"
              :href="child.url"
              :target="child.target || '_self'"
              :title="child.attr_title"
            >
              {{ child.title }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <template v-if="loggedIn">
            <b-nav-item
              class="d-xl-none"
              :to="{ name: 'new_activities', hash: '#profile' }"
            >
              View Profile
            </b-nav-item>
            <b-nav-item
              class="d-xl-none"
              :to="{
                name: 'new_activities',
                hash: '#activities',
              }"
            >
              Activities
            </b-nav-item>
            <b-nav-item
              class="d-xl-none"
              :to="{
                name: 'my_teams',
              }"
            >
              My Teams
            </b-nav-item>
            <!-- <b-nav-item
              v-if="!isKid"
              class="d-xl-none"
              :to="{ name: 'userWallet' }"
            >
              Wallet
            </b-nav-item>
            <b-nav-item class="d-xl-none" :to="{ name: 'seasons' }">
              Seasons
            </b-nav-item> -->
            <b-nav-item
              class="d-xl-none"
              href="javascript:void(0)"
              @click="logout"
            >
              Log Out
            </b-nav-item>

            <b-nav-item-dropdown class="user-account d-none d-xl-block" right>
              <template #button-content>
                <em>{{ user.firstname.substring(0, 1) }}</em>
              </template>
              <b-dropdown-item
                :to="{
                  name: 'new_activities',
                  hash: '#profile',
                }"
              >
                View Profile
              </b-dropdown-item>
              <!-- <b-dropdown-item
                :to="{
                  name: 'userVaultRewards',
                }"
              >
                My Rewards
              </b-dropdown-item> -->
              <b-dropdown-item
                :to="{
                  name: 'new_activities',
                  hash: '#activities',
                }"
              >
                Activities
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'my_teams',
                }"
              >
                My Teams
              </b-dropdown-item>
              <!-- <b-dropdown-item v-if="!isKid" :to="{ name: 'userWallet' }">
                Wallet
              </b-dropdown-item>
              <b-dropdown-item :to="{ name: 'seasons' }">
                Seasons
              </b-dropdown-item> -->
              <b-dropdown-item href="javascript:void(0)" @click="logout">
                Log Out
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </template>

          <template v-else>
            <b-nav-item :to="{ name: 'login' }">Login</b-nav-item>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/commonMixin";

export default {
  name: "HeaderComponent",
  mixins: [commonMixin],

  data() {
    return {
      isMenuOpen: false,
      mainWebsiteUrl: process.env.VUE_APP_MAIN_WEBSITE_URL || "/",
    };
  },

  computed: {
    ...mapGetters("auth", ["user", "loggedIn"]),
    ...mapGetters("user", ["avatar", "profile"]),
    ...mapGetters("menu", [
      "sortedMenuItems",
      "menuLoading",
      "menuError",
      "siteInfo",
    ]),

    isKid() {
      return this.user && this.user.isKid;
    },
  },

  watch: {
    isMenuOpen(newValue) {
      if (newValue) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    },
  },

  created() {
    document.body.classList.add("app-loading");
  },

  mounted() {
    this.$store.dispatch("auth/loggedIn");
    this.$store.dispatch("menu/fetchAllData");
  },

  methods: {
    toggleMobileMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    logout() {
      this.$store.dispatch("auth/logout");
    },

    hasChildren(itemId) {
      return this.$store.getters["menu/hasChildren"](itemId);
    },

    getChildren(itemId) {
      return this.$store.getters["menu/getChildren"](itemId);
    },
  },
};
</script>
